import {
  FocusClass,
  HashLinkFix,
  Initializer,
  JSAttr,
  Toggle,
  Lightbox,
} from 'js-common';

// Controllers
// import SomeController from './SomeController';
import Intro from './Intro';
import ImageSlider from './ImageSlider';
import Instagram from './Instagram';
import Menu from './Menu';

window.Controllers = new Initializer();
// Init in some order of importance
window.Controllers.init('global', document, [
  HashLinkFix,
  JSAttr,
  Toggle,
  Instagram,
  Intro,
  ImageSlider,
  Lightbox,
  Menu,
  // SomeController,
  FocusClass,
]);
